import React from 'react';
import { Refresh } from '@saleshandy/icons';
import ConfirmationModalV3 from '../../../../../../shared/design-system/components/atoms/confirmation-modal/confirmation-modal-v3';

interface IProps {
  show: boolean;
  isRetrying: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const BulkRetryModal: React.FC<IProps> = ({ show, isRetrying, onConfirm, onClose }) => (
  <ConfirmationModalV3
    show={show}
    onSubmit={onConfirm}
    onClose={onClose}
    hideTitleIcon
    showCloseIcon={false}
    icon={<Refresh width={20} height={20} className="blue-txt-6" />}
    title="Retry selected failed tasks?"
    cancelButtonText="Cancel"
    submitButtonText={isRetrying ? 'Retrying...' : 'Retry'}
    isSubmitLoading={isRetrying}
    isSubmitDisabled={isRetrying}
    backdrop="static"
    extraModalProps={{ centered: true }}
    className="bulk-retry-modal"
    content={
      <p className="regular-2 popover-arrow-color-txt">
        This will re-attempt the automation for each selected task. Tasks that
        require a manual fix (e.g. missing fields or invalid URLs) must be
        corrected before retrying.
      </p>
    }
  />
);

export default BulkRetryModal;
